<template>
	<div class="header-dashboard">
		<nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white">
			<div class="container-fluid">

				<!-- Toggler -->
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidebarCollapse" aria-controls="sidebarCollapse" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>

				<!-- Brand -->
				<a class="navbar-brand" href="javascript:void(0)">
					<img :src="logo" class="navbar-brand-img mx-auto" alt="...">
				</a>

				<!-- User (xs) -->
				<div class="navbar-user d-md-none">

					<!-- Dropdown -->
					<div class="dropdown">
					
						<!-- Toggle -->
						<a href="#!" id="sidebarIcon" class="dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<div class="avatar avatar-sm avatar-online">
								<img :src="logo" class="avatar-img rounded-circle" alt="...">
							</div>
						</a>

						<!-- Menu -->
						<div class="dropdown-menu" aria-labelledby="sidebarIconCopy">
							<router-link to="/dashboard/profile" class="dropdown-item">Profile</router-link>
							<hr class="dropdown-divider">
							<a href="javascript:void(0)" class="dropdown-item" @click="loogOut">Logout</a>
						</div>

					</div>

				</div>

				<!-- Collapse -->
				<div class="collapse navbar-collapse" id="sidebarCollapse">
					<!-- Divider -->
					<hr class="my-3">
					
					<!-- Navigation -->
					<ul class="navbar-nav">

						<li class="nav-item">
							<router-link class="nav-link " to="/dashboard/practice-areas" exact>
								<i class="fe fe-layers"></i> Practice Areas
							</router-link>
						</li>

						<li class="nav-item">
							<router-link class="nav-link " to="/dashboard/articles" exact>
								<i class="fe fe-file-text"></i> Articles
							</router-link>
						</li>

						<li class="nav-item">
							<router-link class="nav-link " to="/dashboard/careers" exact>
								<i class="fe fe-briefcase"></i> Careers
							</router-link>
						</li>

						<li class="nav-item dropdown">
							<a class="nav-link" href="#sidebarAbout" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarAbout">
								<i class="fe fe-info"></i> About
							</a>
							<div class="collapse " id="sidebarAbout">
								<ul class="nav nav-sm flex-column">
									<li class="nav-item">
										<router-link to="/dashboard/about/overview" exact class="nav-link">
											Overview (About)
										</router-link>
									</li>
									<li class="nav-item">
										<router-link to="/dashboard/about/story" exact class="nav-link">
											Mission
										</router-link>
									</li>
								
								</ul>
							</div>
						</li>
					</ul>

					<div class="navbar-user mt-auto d-none d-md-flex">
        
						<!-- Dropup -->
						<div class="dropup">
					
							<!-- Toggle -->
							<a href="#!" id="sidebarIconCopy" class="dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<div class="avatar avatar-sm avatar-online">
								<img :src="logo" class="avatar-img rounded-circle" alt="...">
								</div>
							</a>

							<!-- Menu -->
							<div class="dropdown-menu" aria-labelledby="sidebarIconCopy">
								<router-link to="/dashboard/profile" class="dropdown-item">Profile</router-link>
								<hr class="dropdown-divider">
								<a href="javascript:void(0)" class="dropdown-item" @click="loogOut">Logout</a>
							</div>

						</div>

					</div>

				</div> <!-- / .navbar-collapse -->

			</div> <!-- / .container-fluid -->
		</nav>

	</div>
</template>

<script>
var logo = require("@/assets/img/logo.png");
export default {
    name: "Header",
    data() {
        return {
            logo: logo
        };
    },
    methods: {
        loogOut() {
            this.$store.commit("LOGOUT_USER");
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/backend/templates/Header.vue